export default ['global_tags', 'goodreads_imports', 'state_syncing_key_value_pairs', 'state_syncing_updates', 'tracked_books'] as const;
